module.exports = __webpack_public_path__ + "static/media/mktools.ab4737a2.svg";